import React, { useContext } from 'react';
import { Link, Outlet } from "react-router-dom";
import SiteSetting from '../../Context/SiteSetting';
import { useState } from 'react';
import './Template.scss';
import { useTranslation } from 'react-i18next';
import MetaTags from 'react-meta-tags';
import * as Config from "../../Config";

const Template = () => {
  const context = useContext(SiteSetting);
  const [ setting ] = useState(context.setting);
  const { t, i18n } = useTranslation();


  const changeLanguageHandler = (lang) =>
  {
    localStorage.setItem('lang', lang)
    window.location.reload();
    // i18n.changeLanguage(lang);
  }
const accountName = context.setting.name[i18n.language];
  return (<>
    {setting && 
        <div>
            <MetaTags>
                <title>{accountName} - {t('Booking System')}</title>
            </MetaTags>
            <header style={{backgroundColor: setting.primary_color}}>
                <div className='container'>
                    <div className='title'>
                        <Link to={`/${context.setting.slug}`}>
                            {context.setting.logo ? <img src={`${Config.API_HOST}/storage/${context.setting.logo}`} alt={accountName} /> : accountName}
                        </Link>
                        </div>
                    <div className='lang'>
                        <div className='link' onClick={()=>changeLanguageHandler('en')}>English</div>
                        <div className='link' onClick={()=>changeLanguageHandler('he')}>Hebrew</div>
                    </div>
                </div>
            </header>
            <div className='wrapper container'>
                <div className='wrapper-top'>
                    <h1>
                        {context.setting.page_title[i18n.language] ? context.setting.page_title[i18n.language] : t('Registration for Shabbat & Holidays')}
                    </h1>
                    <h2>{accountName}</h2>
                </div>
                <div className='wrapper-content'>
                    <Outlet />
                </div>
            </div>
        </div>
    }
    </>);
};

export default Template;
